// document.addEventListener("DOMContentLoaded", function () {
//   const slider = document.querySelector(".product__review__tooltip .review-slider");

//   if (slider && typeof $(slider).slick === "function") {
//     $(slider).slick({
//       dots: true,
//       infinite: true,
//       speed: 500,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: true,
//     });
//   }


// // OPEN tooltip
// document.addEventListener('click', function (e) {
//   const trigger = e.target.closest('.product-rating.js-show-tooltip');
//   if (!trigger) return;

//   // scope to the same wrapper
//   const wrapper = trigger.closest('[style*="position: relative"]') || trigger.parentElement;
//   const tooltip = wrapper.querySelector('.product__review__tooltip');

//   if (!tooltip) return;

//   tooltip.classList.remove('hidden');
// });

// // CLOSE tooltip
// document.addEventListener('click', function (e) {
//   const closeBtn = e.target.closest('.js-review-tooltip-close');
//   if (!closeBtn) return;

//   closeBtn.closest('.product__review__tooltip')?.classList.add('hidden');
// });

// // DEBUG (optional)
// document.addEventListener('click', () => console.log('CLICK OK'));



// });

document.addEventListener("DOMContentLoaded", function () {

  // OPEN tooltip
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.product-rating.js-show-tooltip');
    if (!trigger) return;

    const wrapper =
      trigger.closest('[style*="position: relative"]') ||
      trigger.parentElement;

    const tooltip = wrapper.querySelector('.product__review__tooltip');
    if (!tooltip) return;

    // Show tooltip
    tooltip.classList.remove('hidden');

    // Init slick AFTER tooltip is visible
    const slider = tooltip.querySelector('.review-slider');
    if (
      slider &&
      window.jQuery &&
      typeof jQuery.fn.slick === 'function' &&
      !slider.classList.contains('slick-initialized')
    ) {
      jQuery(slider).slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      });
    }
  });

  // CLOSE tooltip
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.js-review-tooltip-close');
    if (!closeBtn) return;

    closeBtn
      .closest('.product__review__tooltip')
      ?.classList.add('hidden');
  });

});



document.addEventListener("DOMContentLoaded", () => {
  function init() {
    const checkbox = document.querySelector(".kaching-bundles__subscriptions__checkbox");
    const bars = document.querySelector(".kaching-bundles__bars");

    if (!checkbox || !bars) {
      //console.warn("⚠️ Checkbox or Bars element not found — waiting...");
      return false;
    }

    console.log("✅ Elements found — starting observer");

    function toggleUpsell() {
      const svg = checkbox.querySelector("svg");
      const upsells = bars.querySelectorAll(".kaching-bundles__upsell");
      const svgVisible = svg && (svg.offsetWidth > 0 || svg.offsetHeight > 0 || svg.getClientRects().length > 0);

      if (svgVisible) {
        upsells.forEach(u => {
          u.style.setProperty("display", "block", "important");
        });
        console.log("🟢 SVG visible → Showing all upsells");
        window.kachingBundlesDisableAddToCartHandling = false;
      } else {
        upsells.forEach(u => {
          u.style.setProperty("display", "none", "important");
          u.classList.remove("kaching-bundles__upsell__checkbox--selected");
        });
        console.log("🔴 SVG not visible → Hiding all upsells and removing 'selected' class");
        window.kachingBundlesDisableAddToCartHandling = true;
      }
    }

    // Run once initially
    toggleUpsell();

    // Observe SVG or checkbox DOM changes
    const observer = new MutationObserver(toggleUpsell);
    observer.observe(checkbox, { childList: true, subtree: true, attributes: true });

    console.log("👀 Watching for checkbox SVG visibility changes...");
    return true;
  }

  // Keep checking until DOM ready
  let tries = 0;
  const wait = setInterval(() => {
    const ready = init();
    tries++;
    if (ready || tries > 40) { // ~8 seconds
      clearInterval(wait);
    }
  }, 200);
});


// review box moving below the product image gallary 
document.addEventListener("DOMContentLoaded", function () {
  const DESKTOP_WIDTH = 999;

  const product = document.querySelector(".product");
  if (!product) return;

  const reviewEl = product.querySelector(".pdp-review");
  const thumbnailWrapper = product.querySelector(".product-gallery__thumbnail-list-wrapper");

  if (!reviewEl || !thumbnailWrapper) return;

  // Create placeholder to restore original position
  const placeholder = document.createElement("div");
  placeholder.className = "pdp-review-placeholder";
  reviewEl.parentNode.insertBefore(placeholder, reviewEl);

  function updateReviewPosition() {
    if (window.innerWidth > DESKTOP_WIDTH) {
      // Desktop → move after thumbnails
      thumbnailWrapper.insertAdjacentElement("afterend", reviewEl);
    } else {
      // Mobile → move back to original place
      placeholder.insertAdjacentElement("afterend", reviewEl);
    }
  }

  // Initial run
  updateReviewPosition();

  // On resize
  window.addEventListener("resize", updateReviewPosition);
});


// NEW RES PDP : accordian section after review sec in PDP page product info section
document.addEventListener("DOMContentLoaded", function () {
  const DESKTOP_WIDTH = 999;

  const product = document.querySelector(".product");
  if (!product) return;

  const reviewEl = product.querySelector(".template-turmeric_quantity-based-res-new-layout .pdp-review");
  const accordions = product.querySelectorAll(".template-turmeric_quantity-based-res-new-layout .product-info__accordion");

  if (!reviewEl || accordions.length === 0) return;

  // Create placeholders
  const placeholders = [];
  accordions.forEach(acc => {
    const ph = document.createElement("div");
    acc.parentNode.insertBefore(ph, acc);
    placeholders.push(ph);
  });

  function updateAccordionPosition() {
    if (window.innerWidth > DESKTOP_WIDTH) {
      // Desktop → move after review
      accordions.forEach(acc => {
        reviewEl.insertAdjacentElement("afterend", acc);
      });
    } else {
      // Mobile → restore original position
      accordions.forEach((acc, i) => {
        placeholders[i].insertAdjacentElement("afterend", acc);
      });
    }
  }

  updateAccordionPosition();
  window.addEventListener("resize", updateAccordionPosition);
});

//NEW RES PDP : UGC section after accordian in PDP page product info section
document.addEventListener("DOMContentLoaded", function () {
  const DESKTOP_WIDTH = 999;

  const product = document.querySelector(".product");
  if (!product) return;

  const reviewSlider = product.querySelector(".template-turmeric_quantity-based-res-new-layout .review-slider");
  const accordions = product.querySelectorAll(".template-turmeric_quantity-based-res-new-layout .product-info__accordion");

  if (!reviewSlider || accordions.length === 0) return;

  // Create placeholder
  const sliderPlaceholder = document.createElement("div");
  reviewSlider.parentNode.insertBefore(sliderPlaceholder, reviewSlider);

  function updateSliderPosition() {
    if (window.innerWidth > DESKTOP_WIDTH) {
      // Desktop → move after last accordion
      const lastAccordion = accordions[accordions.length - 1];
      lastAccordion.insertAdjacentElement("afterend", reviewSlider);
    } else {
      // Mobile → restore original position
      sliderPlaceholder.insertAdjacentElement("afterend", reviewSlider);
    }
  }

  updateSliderPosition();
  window.addEventListener("resize", updateSliderPosition);
});

// NEW RES PDP :chnage truct card section position mobile before review slider 
// document.addEventListener("DOMContentLoaded", function () {
//   const trustCard = document.querySelector(".template-turmeric_quantity-based-res-new-layout .trust-card");
//   const reviewSlider = document.querySelector(".template-turmeric_quantity-based-res-new-layout .review-slider");

//   if (!trustCard || !reviewSlider) return;

//   const originalParent = trustCard.parentNode;
//   const originalNextSibling = trustCard.nextElementSibling;

//   function moveElements() {
//     if (window.innerWidth < 999) {
//       // Move trust-card above review-slider
//       if (reviewSlider.parentNode) {
//         reviewSlider.parentNode.insertBefore(trustCard, reviewSlider);
//       }
//     } else {
//       // Move back to original position
//       if (originalNextSibling) {
//         originalParent.insertBefore(trustCard, originalNextSibling);
//       } else {
//         originalParent.appendChild(trustCard);
//       }
//     }
//   }

//   // Run on load
//   moveElements();

//   // Run on resize (optimized)
//   let resizeTimer;
//   window.addEventListener("resize", function () {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(moveElements, 150);
//   });
// });


// Hide icon sec when subscription checkbox is not chaecked
  document.addEventListener("DOMContentLoaded", function () {

    const autoshipEl = document.querySelector('.pp_var_autoship');
    const customBlock = document.querySelector('.custom-block-cls');

    if (!autoshipEl || !customBlock) return;

    function toggleCustomBlock() {
      if (autoshipEl.classList.contains('disabled')) {
        customBlock.style.display = 'none';   // Hide block
      } else {
        customBlock.style.display = '';       // Show block
      }
    }
    toggleCustomBlock();
    const observer = new MutationObserver(toggleCustomBlock);

    observer.observe(autoshipEl, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  // Hide offer block when subscription checkbox is not checked
document.addEventListener("DOMContentLoaded", function () {
  const autoshipEl = document.querySelector('.pp_var_autoship');
  const offerBlock = document.querySelector('.custom-offer-block-off');

  if (!autoshipEl || !offerBlock) return;

  function toggleOfferBlock() {
    if (autoshipEl.classList.contains('disabled')) {
      offerBlock.style.display = 'none'; // Hide block
    } else {
      offerBlock.style.display = ''; // Show block
    }
  }

  toggleOfferBlock();

  const observer = new MutationObserver(toggleOfferBlock);
  observer.observe(autoshipEl, {
    attributes: true,
    attributeFilter: ['class']
  });
});


// https://docs.google.com/document/d/1vKEL2v62omqJ1apWX_gY81XfQnerEFVvn0kzNRoojzI/edit?tab=t.0


// https://support.kachingappz.com/en/articles/8609400-event-listeners-for-kaching-quantity-bundles-widget